const LovableTest = () => {
  return (
    <main className="mx-auto max-w-4xl px-8 py-12">
      <h1 id="hero-title" className="select-text text-4xl font-bold">
        hello world
      </h1>
      <br></br>
      <br></br>
      <p id="intro-text" className="mt-6 select-text text-lg leading-relaxed">
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut
        labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco
        laboris nisi ut aliquip ex ea commodo consequat. And now we have text
      </p>
    </main>
  );
};
export default LovableTest;
